module.exports = __webpack_public_path__ + "static/media/futbol.b076a692.svg";